export default __webpack_public_path__ + "static/media/42.e5693149.jpg";